import { fetchAiFormOptions } from './ai-form-field-callers';
import { AiFormDefinition, AiFormFieldProcessing } from './ai-form.types';

export function budgetProjectId(value: unknown): string {
    if (typeof value !== 'string' || !/^[1-9]\d{0,14}$/.test(value)) {
        throw new Error('Укажите внутренний projectId проекта, найденный через API');
    }
    return value;
}

export const budgetProjectValue: AiFormFieldProcessing = {
    read: value => value == null ? null : String(value),
    write: (value, state) => {
        const id = budgetProjectId(value);
        if (String(state.values['projectId']) !== id) throw new Error('Открыта форма бюджета другого проекта');
        return id;
    },
};

export const resolveBudgetCreatePath: AiFormDefinition['resolveCreatePath'] = async (values, context) => {
    const id = budgetProjectId(values['projectId']);
    const metadata = await fetchAiFormOptions(`/core/projects/${id}/budgets/new/form-metadata`, context.signal, context.requests);
    const creation = metadata.creationContext;
    if (String(metadata.projectId) !== id || !['light', 'spa'].includes(metadata.editor)
        || !creation || typeof creation.hasOrders !== 'boolean'
        || typeof creation.choiceRequired !== 'boolean') throw new Error('Не удалось проверить активный бюджет проекта');
    const choiceRequired = creation.choiceRequired && !(context.state?.ready !== false && context.state?.readOnly === false
        && String(context.state.values['projectId']) === id);
    if (!context.checkOnly && choiceRequired && context.cloneActiveBudget === undefined) {
        throw new Error('По активному бюджету уже есть заявки. Сначала спросите пользователя: создать новый бюджет с потерей привязок старых заявок или клонировать активный и сохранить связи по наименованиям? После ответа передайте cloneActiveBudget=true или false.');
    }
    let path = metadata.editor === 'spa' ? `/core/spa#/projects/${id}/budgets/new`
        : `/core/projects/${id}/budgets/light/new`;
    if (context.cloneActiveBudget) {
        if (creation.activeBudgetId == null) throw new Error('У проекта нет активного бюджета для клонирования');
        const sourceId = budgetProjectId(creation.activeBudgetId);
        if (Object.keys(values).some(key => key !== 'projectId')) {
            throw new Error('Для клонирования передайте только projectId. Сначала откройте и изучите клон, затем изменяйте его через update_current_form по актуальным rowId.');
        }
        path = metadata.editor === 'spa' ? `/core/spa#/projects/${id}/budgets/${sourceId}/clone`
            : `${path}?cloneFromBudgetId=${sourceId}`;
    }
    return { path, context: { ...creation, choiceRequired }, reviewRequired: context.cloneActiveBudget === true };
};

export function isBudgetFormPage(projectId?: string): boolean {
    const match = /^\/core\/projects\/([1-9]\d*)\/budgets\/light\/(?:new|[1-9]\d*)$/.exec(window.location.pathname)
        || (window.location.pathname === '/core/spa'
            && /^#\/projects\/([1-9]\d*)\/budgets\/(?:new|[1-9]\d*(?:\/clone)?)$/.exec(window.location.hash));
    return !!match && (projectId === undefined || match[1] === projectId);
}
